module.exports = __webpack_public_path__ + "static/media/glass-champagne.790fd7b4.svg";